import { SurveyTemplate, SurveyTemplateQuery } from '@dreryk/egabinet-survey-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { appointmentsTranslationKeys } from '../../../../translations';

const PREINTERVIEW_TEMPLATE_CODE = 'PREINTERVIEW';

type PreInterviewFormLoaderRenderProps = {
   preInterviewTemplate: SurveyTemplate;
};

type PreInterviewFormLoaderProps = {
   readonly preInterviewTemplateVersionId?: number;
   readonly children: (renderProps: PreInterviewFormLoaderRenderProps) => JSX.Element;
};

export const PreInterviewFormLoader = (props: PreInterviewFormLoaderProps): JSX.Element => {
   const {
      data: preInterviewTemplate,
      loading: preInterviewTemplateLoading,
      error: preInterviewTemplateError,
   } = useCqrsGet<SurveyTemplate>(() => {
      const query = new SurveyTemplateQuery();
      query.templateCode = Slot.emptyIfNull(PREINTERVIEW_TEMPLATE_CODE);
      query.templateVersionId = Slot.emptyIfNull(props.preInterviewTemplateVersionId ?? null);
      query.published = Slot.emptyIfNull(true);
      return query;
   });

   if (preInterviewTemplateLoading) {
      return <LoaderSpinner />;
   }

   if (preInterviewTemplateError) {
      return (
         <Message
            testId={'preInterviewTemplateFetchError'}
            type={MessageType.NEGATIVE}
            label={appointmentsTranslationKeys.preInterview.failedToFetch}
            displayIndicator
         />
      );
   }

   return props.children({
      preInterviewTemplate: preInterviewTemplate,
   });
};
